import { AfterViewInit, Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { config } from '@app/core/app-config';
import { AuthenticationService } from '@app/core/authentication/authentication.service';

import { IntercomService } from '@app/shared/services/intercom.service';

@Component({
  standalone: false,
  selector: 'sbnb-cs-login',
  templateUrl: './cs-login.component.html',
  styleUrls: ['./cs-login.component.scss'],
})
export class CsLoginComponent implements OnInit, AfterViewInit {
  token: string;
  error: string;

  redirectUrl: string;

  constructor(
    private route: ActivatedRoute,
    private authService: AuthenticationService,
    private intercomService: IntercomService
  ) {}

  ngOnInit() {
    localStorage.removeItem('user');
    localStorage.removeItem('user_permissions');
    localStorage.removeItem('accessToken');

    this.authService.logout(false);
    localStorage.setItem('isCS', 'true');

    this.route.queryParams.subscribe((params) => {
      this.redirectUrl = params['redirect'];
    });

    this.route.params.subscribe((params) => {
      this.token = params['token'];

      if (!this.token) {
        this.error = 'No token provided';
      }

      if (this.token) {
        localStorage.setItem('accessToken', this.token);

        // localStorage set is not instant and has no callback
        setTimeout(() => {
          this.authService.getUserDetailsFromApi().subscribe((res) => {
            if (res.error) {
              this.error = res.msg;
            } else {
              localStorage.setItem('user', JSON.stringify(res));

              this.authService.loginActions(this.redirectUrl ? this.redirectUrl : config.DEFAULT_PAGE);
            }
          });
        }, 100);
      }
    });
  }

  ngAfterViewInit() {
    this.intercomService.shutdown();
  }
}
